'use client';
import { useMetrica } from 'next-yandex-metrica';
import { useCallback, useEffect, useRef } from 'react';

import {
	type ControlsTrack,
	createControlsTracker,
} from '../lib/controls-analytics';
export function useControlsAnalytics(
	mode: string,
	problemId: string,
	dialogId: string,
	entryPoint:
		| 'course'
		| 'roadmap'
		| 'standalone'
		| 'candidate'
		| 'gate' = 'standalone',
) {
	const { reachGoal } = useMetrica();
	const tracker = useRef(
		createControlsTracker(reachGoal, { mode, problemId, entryPoint }),
	);
	tracker.current = createControlsTracker(reachGoal, {
		mode,
		problemId,
		entryPoint,
	});
	const track = useCallback<ControlsTrack>(
		(event, details) => tracker.current(event, details),
		[],
	);
	const seen = useRef<string | null>(null);
	useEffect(() => {
		if (dialogId && seen.current !== dialogId) {
			seen.current = dialogId;
			track('view');
		}
	}, [dialogId, track]);
	return track;
}
